import { PROCESS_TYPES, TEMPLATE_TYPES, TEMPLATES } from "utils/constants";

const b2c = (theme) => TEMPLATES[PROCESS_TYPES.B2C].THEMES[theme];

const defineB2cProspectLinkTargets = ({
  signedStep,
  whenInfoCompleted,
  whenInfoIncomplete,
}) => ({
  ...(signedStep != null ? { signedStep } : {}),
  byInfoCompleted: {
    true: whenInfoCompleted,
    false: whenInfoIncomplete,
  },
});

export const resolveB2cProspectLinkTemplate = (entry, openState) => {
  if (!entry?.byInfoCompleted) {
    return undefined;
  }
  if (openState?.isSigned && entry.signedStep != null) {
    return entry.signedStep;
  }
  return entry.byInfoCompleted[Boolean(openState?.isInfoCompleted)];
};

export const B2C_PROSPECT_LINK_TEMPLATE_BY_THEME = {
  [TEMPLATE_TYPES.DEFAULT]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.DEFAULT).B2C_SUBSCRIPTION_DONE,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.DEFAULT).B2C_SUBSCRIPTION,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.DEFAULT).B2C_SUBSCRIPTION,
  }),
  [TEMPLATE_TYPES.RADIANCE]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.RADIANCE).B2C_SUBSCRIPTION_DONE,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.RADIANCE).JUSTIFICATIONS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.RADIANCE).B2C_SUBSCRIPTION,
  }),
  [TEMPLATE_TYPES.RADIANCE_COSA]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.RADIANCE_COSA).B2C_SUBSCRIPTION_DONE,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.RADIANCE_COSA).JUSTIFICATIONS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.RADIANCE_COSA).B2C_SUBSCRIPTION,
  }),
  [TEMPLATE_TYPES.RADIANCE_AURA_TER]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.RADIANCE_AURA_TER).B2C_SUBSCRIPTION_DONE,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.RADIANCE_AURA_TER).JUSTIFICATIONS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.RADIANCE_AURA_TER).B2C_SUBSCRIPTION,
  }),
  [TEMPLATE_TYPES.B2C_SOLYON]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.B2C_SOLYON).JUSTIFICATIONS,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.B2C_SOLYON).GENERATE_E_SIGN_DOCUMENTS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.B2C_SOLYON).EFFECTIVE_DATE,
  }),
  [TEMPLATE_TYPES.B2C_LMF]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.B2C_LMF).SUBSCRIPTION_DONE,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.B2C_LMF).JUSTIFICATIONS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.B2C_LMF).EFFECTIVE_DATE,
  }),
  [TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY).JUSTIFICATIONS,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY)
      .GENERATE_E_SIGN_DOCUMENTS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.B2C_MUTUAL_MOBILITY)
      .ADHERENT_TELECOMS,
  }),
  [TEMPLATE_TYPES.B2C_MILTIS]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.B2C_MILTIS).JUSTIFICATIONS_AFTER_SIGN,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.B2C_MILTIS).JUSTIFICATIONS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.B2C_MILTIS).EFFECTIVE_DATE,
  }),
  [TEMPLATE_TYPES.B2C_MILTIS_TER]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.B2C_MILTIS_TER).JUSTIFICATIONS_AFTER_SIGN,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.B2C_MILTIS_TER).JUSTIFICATIONS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.B2C_MILTIS_TER).EFFECTIVE_DATE,
  }),
  [TEMPLATE_TYPES.B2C_AMELLIS]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.B2C_AMELLIS).JUSTIFICATIONS,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.B2C_AMELLIS)
      .GENERATE_E_SIGN_DOCUMENTS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.B2C_AMELLIS).EFFECTIVE_DATE,
  }),
  [TEMPLATE_TYPES.B2C_ACORIS]: defineB2cProspectLinkTargets({
    signedStep: b2c(TEMPLATE_TYPES.B2C_ACORIS).JUSTIFICATIONS_AFTER_SIGN,
    whenInfoCompleted: b2c(TEMPLATE_TYPES.B2C_ACORIS).JUSTIFICATIONS,
    whenInfoIncomplete: b2c(TEMPLATE_TYPES.B2C_ACORIS).EFFECTIVE_DATE,
  }),
};
